module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('img', {
    staticClass: "navbar-brand",
    attrs: {
      "src": _vm.logoblanco
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    on: {
      "click": function($event) {}
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/nosotros",
      "tag": "a"
    }
  }, [_vm._v(" " + _vm._s(_vm.state.header.menu1) + " ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/servicios",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.header.menu2))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/infraestructura",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.header.menu3))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/destinos",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.header.menu4))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/clientes",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.header.menu5))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.header.menu6))])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toggleLang()
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.state.header.menu7))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "id": "button-menu",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0512421f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 141
// module chunks = 0